import { AutoScalingGroupProperties } from 'models/auto-scaling-group';
import { ACTIONS_TYPES } from 'redux/helper';
import { service } from 'services';
import { basicCRUDAction, hotGetAction } from 'utils';

export default {
  group: {
    getAll: async () => hotGetAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.GET_ALL,
      apiResult: service.autoScaling.group.getAll(),
      isRetrieveItems: true,
    }),

    create: async (properties = new AutoScalingGroupProperties()) => basicCRUDAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.CREATE,
      apiResult: service.autoScaling.group.create(properties),
    }),

    get: async ({ id }) => hotGetAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.GET,
      apiResult: service.autoScaling.group.get({ id }),
    }),

    update: async ({ id, properties = new AutoScalingGroupProperties() }) => basicCRUDAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.UPDATE,
      apiResult: service.autoScaling.group.update({ id, properties }),
    }),

    delete: async ({ id }) => basicCRUDAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.DELETE,
      apiResult: service.autoScaling.group.delete({ id }),
    }),

    getAllActions: async ({ groupId }) => hotGetAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.GET_ALL_ACTIONS,
      apiResult: service.autoScaling.group.getAllActions({ groupId }),
      isRetrieveItems: true,
    }),

    getAction: async ({ actionId, groupId }) => hotGetAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.GET_ACTION,
      apiResult: service.autoScaling.group.getAction({ actionId, groupId }),
    }),

    getAllServers: async ({ groupId }) => hotGetAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.GET_ALL_SERVERS,
      apiResult: service.autoScaling.group.getAllServers({ groupId }),
      isRetrieveItems: true,
    }),

    getServer: async ({ groupId, serverId }) => hotGetAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.GET_SERVER,
      apiResult: service.autoScaling.group.getServer({ groupId, serverId }),
    }),

    scaleIn: async ({ groupId }) => basicCRUDAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.SCALE_IN,
      apiResult: service.autoScaling.group.scaleIn({ groupId }),
    }),

    scaleOut: async ({ groupId }) => basicCRUDAction({
      action: ACTIONS_TYPES.AUTO_SCALING.GROUP.SCALE_OUT,
      apiResult: service.autoScaling.group.scaleOut({ groupId }),
    }),
  },
};
